module.exports = __webpack_public_path__ + "img/vol05_cup01_name.8f4b9ec0.png";